const state = {
  isDssAccessibilityChecked: null,
  isDSSAccessibleForCompany: {},
};

const getters = {
  isDssAccessibilityChecked: (state) => {
    return state.isDssAccessibilityChecked;
  },
  isDSSAccessibleForCompany: (state) => {
    return state.isDSSAccessibleForCompany;
  },
};

const mutations = {
  setIsDssAccessibilityChecked(state, payload) {
    state.isDssAccessibilityChecked = payload;
  },
  setIsDSSAccessibleForCompany(state, payload) {
    state.isDSSAccessibleForCompany = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
